import routes from './routes'
import useFacebook from '@/composables/facebook'

import { createRouter, createWebHistory } from 'vue-router'
import { useTheme } from '@/composables/theme'
import { event } from 'vue-gtag'
import { storeToRefs } from 'pinia'
import { useCharityStore } from '@/stores/charity'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

router.beforeEach(async (routeTo, routeFrom, next) => {
  const { validateCharity } = useTheme()
  const { onTrack } = useFacebook()
  const charityStore = useCharityStore()
  const { getCharityInfo } = storeToRefs(charityStore)

  // Skip charity validation for error pages to prevent infinite loops
  if (!routeTo.meta.errorPage) {
    try {
      await validateCharity()
    } catch (error) {
      return next({ name: 'error-404' })
    }
  }
  onTrack('ViewContent')
  event('screen_view', {
    app_name: 'Donation Form v2.0',
    screen_name: routeTo.name
  })
  window.analytics.page(`Visited ${routeTo.name}`, {
    charity_id: getCharityInfo.value?.charity_id || '',
    mobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    ),
    browser: navigator.userAgent
  })
  // Check if auth is required on this route
  // (including nested routes).// Check if auth is required on this route
  // (including nested routes).
  const authRequired = routeTo.matched.some((route) => route.meta.authRequired)
  // If auth isn't required for the route, just continue.
  if (!authRequired) return next()

  return next()
})

export default router
